import React from 'react';

import { defineMessages, FormattedMessage } from 'react-intl-next';

import { cssMap, cx } from '@atlaskit/css';
import { Box, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { ErrorIllustration } from '../../assets/ErrorIllustration';

const styles = cssMap({
	wrapper: {
		textAlign: 'center',
		paddingTop: token('space.300'),
		paddingRight: token('space.300'),
		paddingBottom: token('space.300'),
		paddingLeft: token('space.300'),
		width: '360px',
		borderRadius: token('radius.large', '3px'),
	},
	text: {
		color: token('color.text.subtlest'),
		marginTop: token('space.100'),
	},
});

/**
 * CardError component to display an error message when team information cannot be retrieved.
 */
function CardError() {
	return (
		<Box
			xcss={cx(styles.wrapper)}
			testId="team-profilecard-error"
			backgroundColor="elevation.surface.overlay"
		>
			<ErrorIllustration />
			<Text as="p" weight="semibold">
				<FormattedMessage {...messages.title} />
			</Text>
			<Box xcss={styles.text}>
				<FormattedMessage {...messages.text} />
			</Box>
		</Box>
	);
}

const messages = defineMessages({
	title: {
		id: 'pt.team-profile-card.error.title',
		defaultMessage: 'We’re having trouble retrieving this teams information',
		description: 'Title for an error view explaining that data for this team cannot be accessed',
	},
	text: {
		id: 'pt.team-profile-card.error.suggestion',
		defaultMessage: 'Wait a few moments, then try again.',
		description: 'Second line suggesting how to fix the issue',
	},
});

export { CardError };
